import React from 'react'
import { connect } from 'react-redux'

import { getAutoSubs, isAutoSubIntroAcked } from 'store/modules/session/selectors'
import { withRouter, RouteComponentProps } from 'react-router'
import { ackAutosubIntro } from 'services/gamelogic'
import { AutoSubProvider } from 'contexts/AutoSub'
import { AppState } from 'store/types'

const mapStateToProps = ({ session }: AppState) => ({
  isAcknowledged: isAutoSubIntroAcked(session),
  remainingSubs: getAutoSubs(session),
})

type InjectedProps = ReturnType<typeof mapStateToProps> & RouteComponentProps<{}>

const ConnectedAutoSubProvider: React.SFC<InjectedProps> = ({
  remainingSubs,
  isAcknowledged,
  history,
  children,
}) => (
  <AutoSubProvider
    value={{
      remainingSubs,
      isAcknowledged,
      ackAutosubIntro,
      onStoreClick: () => { history.push('/store') },
    }}
  >
    {children}
  </AutoSubProvider>
)

export default withRouter(connect(mapStateToProps)(ConnectedAutoSubProvider))
try {
    // @ts-ignore
    ConnectedAutoSubProvider.displayName = "ConnectedAutoSubProvider";
    // @ts-ignore
    ConnectedAutoSubProvider.__docgenInfo = { "description": "", "displayName": "ConnectedAutoSubProvider", "props": {} };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/components/ConnectedAutoSubProvider/ConnectedAutoSubProvider.tsx#ConnectedAutoSubProvider"] = { docgenInfo: ConnectedAutoSubProvider.__docgenInfo, name: "ConnectedAutoSubProvider", path: "src/components/ConnectedAutoSubProvider/ConnectedAutoSubProvider.tsx#ConnectedAutoSubProvider" };
}
catch (__react_docgen_typescript_loader_error) { }